import React, { useEffect, useState } from 'react'
import { Nav, Navbar, Container, Row, Col, Image, Form } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import logo from '../images/ergusLogo.png';

import '../styles/myHeader.css'

const MyHeader = () => {
    const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
    const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const handleServicesItemClick = () => {
        setServicesDropdownOpen(false); // Close the dropdown when a menu item is clicked

        window.scrollTo(0, 0)
    };

    useEffect(() => {
        if (servicesDropdownOpen === true) {
            setProductsDropdownOpen(false);
        }
    }, [servicesDropdownOpen])

    useEffect(() => {
        if (productsDropdownOpen === true) {
            setServicesDropdownOpen(false);
        }
    }, [productsDropdownOpen])

    const handleProductsItemClick = () => {
        setProductsDropdownOpen(false); // Close the dropdown when a menu item is clicked

        window.scrollTo(0, 0)
    };




    const handleMenuItemClick = () => {
        setExpanded(false);
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    // API isteği için temel bilgiler
    const apiKey = 'ef86b9f706af448fe125832d866ef093'; // OpenWeather API anahtarını buraya ekleyin
    const lat = '40.1858'; // Enlem (latitude)
    const lon = '29.0671'; // Boylam (longitude)
    const units = 'metric'; // Birim türü: 'metric', 'imperial', veya 'standard'
    const lang = 'en'; // Dil: 'en', 'tr', vb.


    useEffect(() => {
        const fetchWeather = async () => {
            const apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=${units}&lang=${lang}`;
            try {
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setWeatherData(data);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchWeather();
    }, []);

    if (loading) return <div>Hava durumu yükleniyor...</div>;
    if (error) return <div>Hata: {error}</div>;


    return (
        <div>
            {weatherData && (
                <div className="header-line">
                    <span className="mx-3">
                        <strong>Şehir: </strong><span style={{ marginLeft: '5px' }}>{weatherData.name}</span>
                    </span>
                    <span className="mx-3">
                        <strong>Sıcaklık: </strong><span style={{ marginLeft: '5px' }}>{weatherData.main.temp} °C</span>
                    </span>
                    <span className="mx-3 d-flex align-items-center">
                        {weatherData.weather?.[0]?.icon && (
                            <img
                                src={`http://openweathermap.org/img/wn/${weatherData.weather[0].icon}@2x.png`}
                                alt="Weather Icon"
                                className="weather-icon mx-2"
                            />
                        )}
                    </span>
                    <span className="mx-3">
                        <strong>Rüzgar Hızı: </strong><span style={{ marginLeft: '5px' }}>{weatherData.wind.speed} km/h</span>
                    </span>
                    
                    <span className="mx-3">
                        <strong>Nem Oranı: </strong><span style={{ marginLeft: '5px' }}>{weatherData.main.humidity} %</span>
                    </span>
                   
                </div>

            )}

            <Navbar expand="lg" fixed='top' className="navbar-background" expanded={expanded}>
                <Container>
                    <Navbar.Brand onClick={handleMenuItemClick}>
                        <Link to="/">
                            <img src={logo} className='logo' alt="logo" />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" onClick={() => setExpanded(expanded ? false : "expanded")} />
                    <Navbar.Collapse id="offcanvasNavbar-expand-lg">
                        <Nav className="me-auto ">
                            <Nav.Link as={Link} to="/" onClick={handleMenuItemClick} className='menu-items2'>Anasayfa</Nav.Link>
                            <Nav.Link as={Link} to="/biyografi" onClick={handleMenuItemClick} className='menu-items2'>Biyografi</Nav.Link>
                            <Nav.Link as={Link} to="/kozmetik-uygulamalar" onClick={handleMenuItemClick} className='menu-items2'>Kozmetik Uygulamalar</Nav.Link>
                            <Nav.Link as={Link} to="/lazer-uygulamalari" onClick={handleMenuItemClick} className='menu-items2'>Lazer Uygulamaları</Nav.Link>
                            <Nav.Link as={Link} to="/kozmetik-uygulamalar-2" onClick={handleMenuItemClick} className='menu-items2'>Tanı ve Tedavi</Nav.Link>
                            <Nav.Link as={Link} to="/iletisim" onClick={handleMenuItemClick} className='menu-items2'>İletişim</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>


                </Container>
            </Navbar>
        </div>
    )
}

export default MyHeader